import { render, staticRenderFns } from "./CedisTable.vue?vue&type=template&id=23b41e1e"
import script from "./CedisTable.vue?vue&type=script&lang=js"
export * from "./CedisTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports